import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { useDispatch } from "react-redux";
import {
  setAdminGridCountySelect,
  setAdminGridDistrictSelect,
} from "../../AdminView/adminSlice";

const DropdownFilterCell = (props) => {
  const dispatch = useDispatch();

  let hasValue = (value) => Boolean(value && value !== props.defaultItem);
  const onChange = (event) => {
    hasValue = hasValue(event.target.value);
    props.onChange({
      value: hasValue ? event.target.value : "",
      operator: hasValue ? "eq" : "",
      syntheticEvent: event.syntheticEvent,
    });
  };
  const onClearButtonClick = (event) => {
    event.preventDefault();
    if (props.field === "district") {
      dispatch(setAdminGridDistrictSelect(""));
    } else if (props.field === "county") {
      dispatch(setAdminGridCountySelect(""));
    }
    props.onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };
  return (
    <div className="k-filtercell">
      <DropDownList
        data={props.data}
        onChange={onChange}
        value={props.value || props.defaultItem}
        defaultItem={props.defaultItem}
      />
      <Button
        title="Clear"
        disabled={!hasValue(props.value)}
        onClick={onClearButtonClick}
        icon="filter-clear"
      />
    </div>
  );
};

export { DropdownFilterCell };
